
import { Injectable } from "@angular/core";


@Injectable({
  providedIn: "root",
})
export class ApiConfiguration {

  //STAGING MVP

  // baseUrl = 'https://hubadminapi.lava.bigcityvoucher.co.in/v1'

  //prod

   baseUrl ='https://hubadminapi.mylavarewards.com/v1'


  login = this.baseUrl + "/hubadmin/log-in";
  logout = this.baseUrl + "/hubadmin/logout";

  //company
  getCompanylist = this.baseUrl + "/hubadmin/list-company";
  addCompany = this.baseUrl + "/hubadmin/add-company";
  editCompany = this.baseUrl + "/hubadmin/edit-company";
  deleteCompany = this.baseUrl + "/hubadmin/deactivate-company";
  generateId = this.baseUrl + "/hubadmin/generate-id";

  orderDetails = this.baseUrl + '/client/getordercumulative'


  //programns

  addPrograms = this.baseUrl + "/hubadmin/add-programs";
  editPrograms = this.baseUrl + "/hubadmin/edit-programs";
  listPrograms = this.baseUrl + "/hubadmin/list-programs"
  deactivateProgram = this.baseUrl + "/hubadmin/deactivate-programs"

  // Product Category

  addCategory = this.baseUrl + "/hubadmin/add-product-cats"
  editCategory = this.baseUrl + "/hubadmin/edit-product-cats"
  listCategory = this.baseUrl + "/hubadmin/list-product-cats"
  deactivateCategory = this.baseUrl + "/hubadmin/deactivate-product-cats"

  //variation-masters 
  addVariationMas = this.baseUrl + "/hubadmin/add-variation-mas"
  listVariationMas = this.baseUrl + "/hubadmin/list-variation-mas"

  // variation
  addVariation = this.baseUrl + "/hubadmin/add-variation"
  listVariation = this.baseUrl + "/hubadmin/list-variation"

  // Products
  uploadProductFile = this.baseUrl + "/hubadmin/product-excel-upload"

  addProducts = this.baseUrl + "/hubadmin/add-product"

  // /Products-variation
  uploadProductVarFile = this.baseUrl + "/hubadmin/product-variation-upload"

  // ListOFProducts
  ListOfProducts = this.baseUrl + "/hubadmin/list-product"
  editProducts = this.baseUrl + "/hubadmin/edit-product"
  deleteDenomination = this.baseUrl + "/hubadmin/disable-denomination"

  //delivery partner
  getdelPartnerList = this.baseUrl + "/delivery-partner/get-partner?";

  // Units
  configGetUnit = this.baseUrl + "units/get-units";
  configAddUnit = this.baseUrl + "units/create-unit";
  configEditUnit = this.baseUrl + "units/update-unit?id=";

  //Redemption Panel
  getOrderList = this.baseUrl + "/redemption/order-listing?";
  getListProgram = this.baseUrl + "/hubadmin/list-programs";
  uploadEGVOrderStatus = this.baseUrl + "/redemption/order-offer-code-upload";
  uploadPhysiaclOrderStatus = this.baseUrl + "/redemption/order-statusupload";
  rejectDropdown = this.baseUrl + "/redemption/rejection-reason"; // rejected reason
  approveRejectOrder = this.baseUrl + "/redemption/approve-rejectby-bcp";
  deliveryPartner = this.baseUrl + "/redemption/delivery-partner";



  changeOrderStatusByForm = this.baseUrl + "/ops-panel/bulk-status-update?program_id=1";
  changeOrderStatusByeExcel = this.baseUrl + "/ops-panel/order-statusupload?program_id=1";
  getDownOrderExlData = this.baseUrl + "/ops-panel/get-orderexcel";
  getCancelReasonDropDown = this.baseUrl + "/ops-panel/get-order-cancelling-reason";

  getVoucherCodes = this.baseUrl + "/redemption/offercode"

  // targetUserFilter = 
  getTargetAchivementList = this.baseUrl + "loyalty-target/get-targets";
  updateTargetAchivement = this.baseUrl + "loyalty-target/update-target";
  addTargetAchivement = this.baseUrl + "loyalty-target/create-target";
  assignedLoyaltyTarget = this.baseUrl + "loyalty-target/get-loyalty-targets";
  createWhitelist = this.baseUrl + "user-modules/create-user-module";
  getModule = this.baseUrl + "module/get-modules";
  getUserModules = this.baseUrl + "user-modules/get-user-modules";
  createLoyalty = this.baseUrl + "loyalty-target/add-target-point-structure";
  getAssignedUser = this.baseUrl + "loyalty-target/get-assigned-users";
  getLoyaltyTargets = this.baseUrl + "loyalty-target/get-loyalty-targets";
  updateLoyaltyTarget = this.baseUrl + "loyalty-target/update-loyalty-target";
  downloadTargetFile = this.baseUrl + 'loyalty-target/download-target-details';
  downloadAchievementExcel = this.baseUrl + 'loyalty-target/download-achievement-target?program_id=1';

  // Reverse Points
  ReversePoints = this.baseUrl + "/redemption/reversal-panel";
  RedemptionReversePoint = this.baseUrl + "/redemption/reverse-point"
  // physical reward
  downloadEgvRewards = this.baseUrl + "/redemption/egv-summary"
  downloadPhysicalRewardExcel = this.baseUrl + "/redemption/order-summary";
  orderStatus = this.baseUrl + "/redemption/readorderstatus";
  deliveryPatner = this.baseUrl + "/redemption/delivery-partner";
  storeStatus = this.baseUrl + "/redemption/setorderstatus";

  //Finance
  getProformaInvoice = this.baseUrl + "/client/getperforma?";
  approveSingleInvoice = this.baseUrl + "/client/setapprovalstatus?new_approval_status=2";
  downloadSingleInvoice = this.baseUrl + "/finance/proforma-download?";
  uploadInvoiceStatus = this.baseUrl + "/hubadmin/upload-invoice";
  getInvoiceList = this.baseUrl + "/hubadmin/list-invoice?";
  getServiceInvoiceList = this.baseUrl + "/finance/list-service-profoma?service_pi_status=2&invoice_flag=1"
  generatePI = this.baseUrl + "/finance/generate-proforma";
  verifyInvoice = this.baseUrl + "/hubadmin/verify-invoice?invoice_id=";
  updateInvoiceStatus = this.baseUrl + "/finance/update-invoice-status"
  downloadProofZip = this.baseUrl + "/client/download-invoice-proofs?invoice_id=";
  deliverOrders = this.baseUrl + '/finance/delivered-orders'
  servicesPI = this.baseUrl + '/finance/service-profoma'
  getServicePI = this.baseUrl + "/finance/list-service-profoma?service_pi_status=2&invoice_flag="
  uploadPayment = this.baseUrl + "/finance/upload-service-payment"
  uploadInvoiceService = this.baseUrl + "/finance/upload-invoice-service"
  //Agent Panel
  getAgentOrderList = this.baseUrl + "/report/customer-orders?";
  getSingleRedemptionInfo = this.baseUrl + "/redemption/offercode"
  getAgentOldOrdersList = this.baseUrl + "/report/old-redemptions"

  // Engagement
  whiteListEngagementUser = this.baseUrl + "/engagement/whitelist-engagement";
  engagementList = this.baseUrl + "/engagement/list-engagement";
  viewEngagementDetail = this.baseUrl + "/engagement/view-engagement?program_id=1";
  createContentAndLarning = this.baseUrl + "/engagement/create-engagement-content";
  engagementTypes = this.baseUrl + "/engagement/engagementtypes";
  engagementElement = this.baseUrl + "/engagement/engagementelementtypes?program_id=1";
  createImageEngagement = this.baseUrl + "/engagement/create-engagement";
  userwhitelist = this.baseUrl + '/engagement/whitelist-engagement-user'
  engagemetnWhitelistUser = this.baseUrl + "/engagement/user-whitelisted";
  deactiveEnagegementUser = this.baseUrl + "/engagement/deactivate-whitelist";
  uploadInstructionImage = this.baseUrl + "/engagement/upload-instruction-image";
  createEngagementQuiz = this.baseUrl + "/engagement/create-engagement-content"
  // getAssigned_users = this.baseUrl + "/engagement/user-whitelisted"
  disableEngagement = this.baseUrl + "/engagement/disable-engagement"
  getEngagementTemplateDetail = this.baseUrl + "/engagement/elementdata";

  getEngagementById = this.baseUrl + "/engagement/get-engagements?id=";
  getEngagementTemplateById = this.baseUrl + "/engagement/get-picture-template?task_id=";

  setQuizCreationCompleteForcampaign = this.baseUrl + "/engagement/set-quiz-creation-complete-forcampaign";
  pointCalcEngagement = this.baseUrl + "/engagement/calculate-points";

  //ROLES
  // OLD API
  configGetRoles = this.baseUrl + "user-role/get-user-roles";
  // NEW
  enagagementgetrole = this.baseUrl + '/engagement/get-role'
  getRoles = this.baseUrl + "/user-role/get-role";
  downloadUserExcel = this.baseUrl + "/users/download-user-excel?program_id=1";

  configAddRoles = this.baseUrl + "/user-role/create-user-role";
  configUpdateRoles = this.baseUrl + "user-role/update-user-role"; //same for delete

  createRole = this.baseUrl + "/user-role/create-role?program_id=1";

  //Visibility /get-posm-config
  getVisibilityList =
    this.baseUrl + "visibility/get-posm-elements?program_id=1";
  addVisibility = this.baseUrl + "visibility/create-posm-elements";
  editVisibility = this.baseUrl + "visibility/update-posm-elements";
  deleteVisibility = this.baseUrl + "visibility/delete-posm-elements";
  saveVisibilityConfig = this.baseUrl + "visibility/create-posm-config";
  getVisibilityConfig =
    this.baseUrl + "visibility/get-posm-config?program_id=1";
  updateVisibilityConfig = this.baseUrl + "visibility/update-posm-config";
  getVisibilitySubmittedList =
    this.baseUrl +
    "/visibility/get-posm-audit-transactions?page=";
  visibilityApproveOrReject =
    this.baseUrl + "visibility/posm-audit-approve-reject";
  getPosmOnChannel = this.baseUrl + 'visibility/get-channel-posm-elements?program_id=1&channel_id=';
  getShelfConditions = this.baseUrl + 'visibility/get-shelves-cooler-purity?program_id=1'
  getShelfConditionsForSubmission = this.baseUrl + 'visibility/get-shelves-points?program_id=1&posm_master_config=';

  // Balance Check
  // Region
  configGetRegion = this.baseUrl + "region/get-region?program_id=1";
  configAddRegion = this.baseUrl + "region/create-region";
  configUpdateRegion = this.baseUrl + "region/update-region";
  configDeleteRegion = this.baseUrl + "region/delete-region";
  importExcelRegion = this.baseUrl + "region/import-region";
  userPointSummary = this.baseUrl + 'staff/get-user-points?id='


  //multilanguage
  engagementMultilang = this.baseUrl + "engagement/engagement-multilang";
  deleteQuestionAndOption = this.baseUrl + "engagement/delete-question-and-options";
  dynamicRoleMultilang = this.baseUrl + "user-role/dynamic-field-multilang";

  // Languages
  configGetLanguages = this.baseUrl + "/language/get-languages?program_id=1";
  configAddLanguage = this.baseUrl + "language/create-language";
  configEditLanguage = this.baseUrl + "language/update-language";
  configDeleteLanguage = this.baseUrl + "language/delete-language";

  // Rewards Categoreies
  getListRewardCategory = this.baseUrl + "/hubadmin/list-product-cats";
  addRewardCategory = this.baseUrl + "/hubadmin/add-product-cats";
  editRewardCategory = this.baseUrl + "/hubadmin/edit-product-cats";

  // Rewards Products add
  getRewardsProductsList = this.baseUrl + "/hubadmin/list-product";
  getCategories = this.baseUrl + "/hubadmin/list-product-cats";
  uploadBulkProducts = this.baseUrl + "/hubadmin/product-excel-upload";
  disableProduct = this.baseUrl + "/hubadmin/active-deactive";
  editProduct = this.baseUrl + "/hubadmin/edit-product";

  my_rewards_list = this.baseUrl + "/scratch-cards/scratch-card-headers";
  upload_my_rewards = this.baseUrl + "/scratch-cards/import-scratch-card";
  create_reward_brand = this.baseUrl + "/rewards/create-reward-brands";
  get_reward_brand = this.baseUrl + "/rewards/get-reward-brands";
  update_reward_brand = this.baseUrl + "/rewards/update-reward-brands";
  delete_reward_brand = this.baseUrl + "/rewards/delete-reward-brands";

  // Instant Voucher Upload
  uploadInstantVoucher = this.baseUrl + "/rewards/instant-voucher-upload";
  getInstantVoucherCodes = this.baseUrl + "/rewards/list-instant-product";

  //states
  configGetStates = this.baseUrl + "/state/get-state?program_id=1";
  configAddState = this.baseUrl + "/state/create-state";
  configEditState = this.baseUrl + "/state/update-state";
  configDeleteState = this.baseUrl + "/state/delete-state";
  importExcelState = this.baseUrl + "/state/import-state";
  //Cities
  configGetCities = this.baseUrl + "/city/get-city";
  configAddCity = this.baseUrl + "/city/create-city";
  configEditCity = this.baseUrl + "/city/update-city";
  configDeleteCity = this.baseUrl + "/city/delete-city";
  importExcelCity = this.baseUrl + "/city/import-city";


  //reward category
  getRewardCategories = this.baseUrl + "/rewards/get-reward-category";
  addRewardCategories = this.baseUrl + "/rewards/create-reward-category";
  editRewardCategories = this.baseUrl + "/rewards/update-reward-category";
  deleteRewardCategories = this.baseUrl + "/rewards/delete-reward-category";
  rewardHistory = this.baseUrl + "/rewards/get-reward-orders?program_id=1";
  getRewardProducts = this.baseUrl + "/rewards/get-reward-products";
  getRewardProductbyId =
    this.baseUrl + "/rewards/get-reward-products?program_id=1&id=";
  createRewardProducts = this.baseUrl + "/rewards/create-reward-products";
  updateRewardProducts = this.baseUrl + "/rewards/update-reward-products";
  deleteRewardProducts = this.baseUrl + "/rewards/delete-reward-products";
  getRewardSubCategory = this.baseUrl + "/rewards/get-reward-sub-categories?program_id=1&reward_category_id=";
  getRewardsBrands = this.baseUrl + "/rewards/get-reward-category-brands?program_id=1&reward_category_id=";

  //reward sub category
  getRewardSubCategories = this.baseUrl + "/rewards/get-reward-subcategory";
  addRewardSubCategories = this.baseUrl + "/rewards/create-reward-subcategory";
  editRewardSubCategories = this.baseUrl + "/rewards/update-reward-subcategory";
  deleteRewardSubCategories =
    this.baseUrl + "/rewards/delete-reward-subcategory";
  //Reward Type
  getRewardType = this.baseUrl + "/reward-type/get-reward-types";

  uploadRewardsCategories = this.baseUrl + "/rewards/import-reward-category?";
  uploadRewardsSubCategories =
    this.baseUrl + "/rewards/import-reward-sub-category?";
  uploadRewardBrands = this.baseUrl + "/rewards/import-reward-brands?";
  checker_maker_bonous_points = this.baseUrl + "/loyalty-target/get-bonous?";

  getReardProductsWithPagination =
    this.baseUrl + "/rewards/get-reward-products-filter?";
  uploadMultiRewards = this.baseUrl + "/rewards/create-reward-products-excel";


  // Frequency
  configGetFrequency = this.baseUrl + "/frequency/get-frequency";
  configAddFrequency = this.baseUrl + "/frequency/create-frequency";
  configEditFrequency = this.baseUrl + "/frequency/update-frequency";


  //Features
  createFeatures = this.baseUrl + "/user-role/create-features?";
  deleteFeatures = this.baseUrl + "/user-role/delete-features?id=";

  //***REWARDS***//
  getAllOffers =
    this.baseUrl + "/ecommerce/loaddata-for-offer-details?program_id=1";
  //Schemes
  getSchemes = this.baseUrl + "/scheme/get-scheme";
  addSchemes = this.baseUrl + "/scheme/create-scheme-data";
  getSchemeConfig = this.baseUrl + "/scheme/get-scheme?id=";
  getSchemeProductCategory = this.baseUrl + "/scheme/get-brand-category";
  extendScheme = this.baseUrl + "/scheme/update-scheme-date?id=";
  getSchemeConfigSettings = this.baseUrl + "/";
  updateScheme = this.baseUrl + "/scheme/update-scheme?id=";
  downloadSchemeUserExcel =
    this.baseUrl + "/scheme/download-users?program_id=1";

  uploadSchemeUserExcel = this.baseUrl + "/users/intermediate-user";
  getSpinWheels = this.baseUrl + "/spin-wheel/list-spin-config?id=";


  // Agent Panel Engaments
  beersDashboard = this.baseUrl + "/visibility/beer-task-details";
  spiritDashboard = this.baseUrl + "/visibility/spirts-task-details";
  beersOotherImageTask = this.baseUrl + "/visibility/other-image-task-beers";
  updateBeersOtherImageTask =
    this.baseUrl + "/visibility/other-image-task-verification-beers";
  getPosmBeers = this.baseUrl + "/visibility/posm-beers";
  getBrandingBeers = this.baseUrl + "/visibility/branding-beers";
  updateBrandingBeers =
    this.baseUrl + "/visibility/branding-verification-beers";
  updateBeersPosmTask = this.baseUrl + "/visibility/posm-verification-beers";
  chillerVisibilityBeers =
    this.baseUrl + "/visibility/chiller-visibility-beers";
  updateChillarVisibilityBeers =
    this.baseUrl + "/visibility/chiller-verification-beers";
  warmStackBeers = this.baseUrl + "/visibility/warm-stock-visibility-beers";
  updateWarmStackBeers =
    this.baseUrl + "/visibility/warm-stock-verification-beers";
  shelfBeers = this.baseUrl + "/visibility/shelf-visibility-beers";
  updateShelfBeers = this.baseUrl + "/visibility/shelf-verification-beers";
  editShelfSpirits = this.baseUrl + "/visibility/shelf-verification-sprits";

  // Agent Panel Ticket lists
  getTicketsList = this.baseUrl + "/visit-tracker/get-tickets?program_id=1";
  approveRejectTicket =
    this.baseUrl + "/visit-tracker/approve-reject-ticket?program_id=1";

  //Enrollment
  getEnrollments = this.baseUrl + "/visit-tracker/get-enrollments?program_id=1";
  getReasons = this.baseUrl + "/visit-tracker/rejection-reasons?program_id=1";
  bulkApprove = this.baseUrl + "/visit-tracker/bulk-verification";
  getBeatsByFse = this.baseUrl + "/visit-tracker/fse-beats?supervisor_id=";
  bulkApproveReject = this.baseUrl + "/users/bulk-approve-reject-slab";
  updateAddress = this.baseUrl + "/visit-tracker/update-user-address";

  getMasterDataList = this.baseUrl + "/user-role/select-tables";
  getValidationList = this.baseUrl + "/user-role/get-fieldvalidation";

  //Bannres
  bannersList = this.baseUrl + "/banner/get-banner?program_id=1";
  createBanner = this.baseUrl + "/banner/create-banner?program_id=1";
  updateBanner = this.baseUrl + "/banner/update-banner?program_id=1";
  deleteBanner = this.baseUrl + "/banner/delete-banner?program_id=1";
  getbannerrole = this.baseUrl + "/banner/get-role?"


  //reports
  redemptionReport = this.baseUrl + '/report/redemption-report'
  enrolmentReport = this.baseUrl + '/report/enrolment-report'
  pointsLedgerReport = this.baseUrl + '/report/points-ledger-report'
  catalogueReport = this.baseUrl + '/report/sku-report'
  loginReport = this.baseUrl + '/report/login-report'
  cancellationReport = this.baseUrl + '/report/cancellation-report'
  pointBalanceReport = this.baseUrl + '/report/pointbalance-report'
  deductionReport = this.baseUrl + '/report/deduction-report'
  engagementReport = this.baseUrl + '/report/engagement-report'




  getAmozonWoohoBalance = this.baseUrl + '/common/check-balance?&secret_key=$2y$10$z0ihWtyW2HsEAh1VMNbGUOXKN1w9RJo8Vgwb6PLCsQLU.F2OcVU5W'


  //  Reward window
  getDisableStatus = this.baseUrl + "/hubadmin/get-reward-window-configuration?program_id=1"
  updateRewardsStatus = this.baseUrl + '/hubadmin/update-reward-window-configuration?program_id=1'


  //concierge
  getUserDetails = this.baseUrl + '/hubadmin/userdetails?program_id=1';
  getLedgerDetails = this.baseUrl + '/hubadmin/user-ledger?program_id=1';
  userEngagementDetails = this.baseUrl + "/hubadmin/user-engagement-details?program_id=1"

  //Operational Head
  getRedemptiondetailss = this.baseUrl + '/redemption/failure-order-data';
  getSucessRedemptiondetails = this.baseUrl + '/redemption/success-order-data';
}
export interface ApiConfigurationInterface { }